import React, { useEffect } from "react";
import logo from "../assets/img/logo1.png";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import LogoutIcon from "@mui/icons-material/Logout";
import { Box } from "@mui/system";
//import { Container, Tooltip } from "@mui/material";
import { Container, Tooltip } from "@mui/material";
import { Link,useNavigate } from "react-router-dom";
import useGlobalState from "../Context";
import { cleanInitialState } from "../reducer/action";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { useLoading } from "../common/LoadingContext";
import { useNotificationContext } from "../common/NotificationContext";
import { LogoutService } from "../services/LoginService";
import Badge from '@mui/material/Badge';
import { fetchNotificationDetailsService } from "../services/UserOnboardingService";
import { setNotificationsCount } from "../reducer/action";
import { useIdleTimer } from "react-idle-timer";
import { useState } from "react";
import IdealTimerDialog from "./IdealTimerNotification";
const Header = () => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [{ auth, notificationCount }, dispatch] = useGlobalState();
  const navigate = useNavigate();
  


  const timeout = 900000;
  const promptBeforeIdle=30000;
  const [remaining, setRemaining] = useState(timeout);
  const [alertOpen, setAlertOpen] = useState(false);

  const handleOnActive = () =>{
    setRemaining(timeout);
  };

  const handleOnIdle = () =>{
    handleLogout();
    window.location.reload(true);
  };

  const handleOnClose = () =>{
    handleReset();
    setAlertOpen(false);
  };

  const onPrompt = () =>{
    setAlertOpen(true);
  };
 

  const {
    reset,
    getRemainingTime,
  } = useIdleTimer({
    timeout,
    promptBeforeIdle,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
    onPrompt: onPrompt
  });

  const handleReset = () => {
    reset();
    setRemaining(timeout);
  };

  useEffect(() => {
    setRemaining(getRemainingTime());
    const interval = setInterval(() => {
      setRemaining(getRemainingTime());
    }, 1000);
    return () => clearInterval(interval);
  }, []);






  const handleLogout = async () => {
       try {
      setLoading(true);
      const requestBody = {
        username: auth?.ldapParam?.username.toLowerCase(),
        loggedIn: false
      }
     const response = await LogoutService(requestBody);
     if (response.statusCode === 6) {
        showNotification("Success", response.message, "success");
        dispatch(cleanInitialState());
        localStorage.removeItem("SPMS_INTERNAL_STATE");
        localStorage.removeItem("partTypeListItem");
        sessionStorage.removeItem("token&userId");
        localStorage.removeItem("email");
        navigate("/login");

      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to Logout");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const interval = setInterval(() => {
     fetchNotificationDetails();
     
    }, 180000);
    return () => clearInterval(interval);
  }, []);
  const fetchNotificationDetails = async (page) => {
    try {
      //setLoading(true);
      const reqBody = {
        userId: auth?.ldapParam?.userId,
        read: false,
        userType: auth?.ldapParam?.userType,
      };

      const response = await fetchNotificationDetailsService(reqBody);
      if (response.statusCode === 6) {
        //console.log("response", response);
        dispatch(setNotificationsCount(response.data));
      } else {
        //showNotification("Error", response.message, "error");
      }
    } catch (err) {
      // showNotification("Error", err.message ?? "Failed to fetch  details");
    } finally {
      //setLoading(false);
    }
  };

  return (
    <AppBar
      sx={{ backgroundColor: "#fff", width: `calc(100% - ${220}px)` }}
      position="fixed"
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ ml: 0 }}>
          <div className="logoContainer">
          <Link to="/notifications">
            <img src={logo} alt="reliance retail" title="pbg spare" />
          </Link>

        <div className="projectLogo">

          <div title="R-STP" className="navBarTitle">
            <Link  to="/notifications"> R-STP</Link>
          </div>

            <div title="Spare Part Management" className="spmsHeading">
            <Link  to="/notifications"> Reliance Spare & Technical Portal </Link>
            </div>
          </div>
        </div>
          <Box sx={{ flexGrow: 1 }} />
       
          <Tooltip title="Notifications">
            <IconButton onClick={() => { navigate("/notifications") }

            } color="primary">
              <Badge badgeContent={notificationCount} color="secondary">
                <NotificationsActiveIcon sx={{ color: "#567AAC" }} />
              </Badge>
             
            </IconButton>
          </Tooltip>
         
             <Tooltip title="Logout">
            <IconButton onClick={handleLogout} color="primary">
              <LogoutIcon />
            </IconButton>
          </Tooltip>

        
        </Toolbar>

        <IdealTimerDialog
        openDialog={alertOpen}
        handleClose={handleOnClose}
        handleLogOut={handleLogout}
        remainingTime={Math.ceil(remaining / 1000)}
        />
      </Container>
    </AppBar>
  );
};

export default Header;
